import { Grid } from '@material-ui/core'
import React , {useContext} from 'react'
import { ElasticForm } from './ElasticForm';
import { Logo } from '../../shared/components/Logo'
import './styles/Inicio.css';
import TagManager from 'react-gtm-module';
import { UniversityContext } from "../../routes/AppRouter";
import { versionApp,month,year } from '../../utils/deployData';
export const Inicio = ({match}) => {
    const [ universidad ] = useContext(UniversityContext);

    //Marca visita de google analytics
    const nombreUniversidad = ""+universidad.id;
    TagManager.dataLayer({
        dataLayer: {
        event: 'visita',
        pagePath: 'investigador',
        university: nombreUniversidad,
        },
    });

    return (
        
        <div className="inicio">
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <Grid
                    container
                    item
                >
                    <Logo />

                </Grid>
            </Grid>
            <Grid
                container
                direction="column"
                alignItems="center"
            >
                <Grid 
                    container 
                    item 
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="center"
                >
                    <p className="explainText"> Portafolio de capacidades I + D de nuestros centros y comunidad de investigadores</p>
                    <div className="version">(Versión Beta)</div>
                    <div className='version version--bottom'>
                        Versión {versionApp} | Sincronización <span className='capitalize-first'>{ month }</span> { year }
                    </div>
                </Grid>
            </Grid>
            <ElasticForm isInicio match={match}/>
        </div>
    )
}
